"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "execAction", {
    enumerable: true,
    get: function() {
        return execAction;
    }
});
const _logger = /*#__PURE__*/ _interop_require_default(require("@lage-run/logger"));
const _initializeReporters = require("../initializeReporters.js");
const _executeInProcess = require("./executeInProcess.js");
const _executeRemotely = require("./executeRemotely.js");
const _config = require("@lage-run/config");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function execAction(options, command) {
    const cwd = options.cwd ?? process.cwd();
    const config = await (0, _config.getConfig)(cwd);
    const logger = (0, _logger.default)();
    options.cwd = cwd;
    options.logLevel = options.logLevel ?? "info";
    options.reporter = options.reporter ?? "json";
    await (0, _initializeReporters.initializeReporters)(logger, options, config.reporters);
    const { server } = options;
    if (server) {
        logger.info("Running in server mode");
        if (typeof options.tasks === "undefined") {
            throw new Error("No tasks specified, this is required for when running in server mode");
        }
        await (0, _executeRemotely.executeRemotely)(options, command);
    } else {
        await (0, _executeInProcess.executeInProcess)({
            logger,
            args: command.args,
            cwd: options.cwd,
            nodeArg: options.nodeArg
        });
    }
}
